import { useEffect, useState } from "react";

export function DarkModeToggle() {
  const [darkModeOn, setDarkModeOn] = useState(false);

  useEffect(
    function () {
      darkModeOn
        ? document.body.classList.add("darkMode")
        : document.body.classList.remove("darkMode");
    },
    [darkModeOn]
  );
  return (
    <div className="toggle-section">
      <span className="toggle" onClick={() => setDarkModeOn((curr) => !curr)}>
        <span className="toggle__bg"></span>
        <span
          className={darkModeOn ? "toggle__fg toggle__fg--dark" : "toggle__fg"}
        ></span>
      </span>
      <span className="moon-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 10.449C0.998458 12.8283 1.80169 15.1383 3.27914 17.0033C4.75659 18.8683 6.82139 20.1788 9.13799 20.7218C11.4545 21.2647 13.8866 21.0082 16.039 19.994C18.1912 18.9797 19.9373 17.2673 20.9931 15.1352C11.5442 15.1352 6.85799 10.4479 6.85799 1C5.09842 1.87311 3.61767 3.22033 2.58266 4.88981C1.54765 6.5593 0.999502 8.48469 1 10.449Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </div>
  );
}
